import { Box, CardContent, Typography } from '@mui/material';
import { Icon } from '@ui/Icon';
import React from 'react';

export const PaywallCardFeatures = ({
  features,
  header,
}: {
  features: string[];
  header: string;
}) => {
  return (
    <CardContent>
      <Typography
        variant="body1"
        sx={{
          paddingBottom: 4,
        }}
      >
        {header}
      </Typography>
      {features.map((feature, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            marginBottom: 4,
          }}
        >
          <Icon category="mui" icon="Check" size="small" color="text.primary" />
          <Typography variant="body2">{feature}</Typography>
        </Box>
      ))}
    </CardContent>
  );
};
